<template>
  <div class="gift-panel">
    <div class="gift-card">
      <!-- Search + Sort -->
      <div class="gift-toolbar">
        <div class="gift-search">
          <i class="uil-search gift-search__icon" aria-hidden="true"></i>
          <input
            v-model="filter.search"
            :placeholder="$t('general.search')"
            class="gift-search__input"
            type="search"
          />
        </div>
        <div class="gift-toolbar__actions">
          <a :uk-tooltip="$t('filters.sort_list')" class="gift-sort-btn" href="#">
            <i class="uil-list-ui-alt"></i>
          </a>
          <div uk-dropdown="pos: bottom-right; mode: click; animation: uk-animation-scale-up" class="uk-dropdown">
            <ul class="uk-nav uk-dropdown-nav">
              <li @click="sortOrder('name', 'asc')"><a href="javascript:void(0)">{{ $t('sorting.a_z') }}</a></li>
              <li @click="sortOrder('name', 'desc')"><a href="javascript:void(0)">{{ $t('sorting.z_a') }}</a></li>
              <li @click="sortOrder('created_at', 'asc')"><a href="javascript:void(0)">{{ $t('sorting.created_at_asc') }}</a></li>
              <li @click="sortOrder('created_at', 'desc')"><a href="javascript:void(0)">{{ $t('sorting.created_at_desc') }}</a></li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="gift-table-wrap">
        <table class="table align-items-center gift-table">
          <thead>
            <tr>
              <th scope="col">{{ $t('gift.name') }}</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody class="list">
            <tr v-for="gift in formattedItem" :key="gift.id">
              <th scope="row">
                <div class="media align-items-center">
                  <div class="gift-avatar-wrap">
                    <img :src="gift.image" alt="" class="gift-avatar" />
                  </div>
                  <div class="media-body gift-name">
                    {{ gift.name }}
                  </div>
                </div>
              </th>
              <td class="text-right">
                <div class="gift-actions">
                  <button
                    v-if="selected_items.includes(gift.id)"
                    disabled
                    class="btn btn-sm btn-success gift-action-btn gift-action-btn--added"
                  >
                    <i class="uil-check"></i> {{ $t('general.added') || 'Eklendi' }}
                  </button>
                  <button
                    v-else
                    class="btn btn-sm btn-primary gift-action-btn"
                    @click="$emit('addNewGift', gift)"
                  >
                    <i class="uil-plus"></i> {{ $t('general.add') || 'Ekle' }}
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <pagination
        v-if="pagination && pagination.hasOwnProperty('links')"
        :pagination="pagination"
        @changePage="setPage($event)"
      />
    </div>
  </div>
</template>

<script>
import store from '@/core/services'
import Pagination from "@/assets/components/Pagination";
import gift_module, {
  BASE_URL as GIFT_BASE_URL,
  MODULE_NAME as GIFT_MODULE_NAME,
  ERROR as GIFT_ERROR,
  ITEMS as GIFT_ITEMS,
  GET_ITEMS as GIFT_GET_ITEMS,
  DELETE_ITEM as GIFT_DELETE_ITEM,
} from "@/core/services/store/gift.module";

export default {
  name: "GiftForAssignment",
  components: { Pagination },
  props: {
    selected_items: {
      required: true,
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      status_id: null,
      pagination: null,
      activeItem: null,
      successMessage: null,
      errorMessages: [],
      page: 1,
      per_page: 10,
      sort_by: "id",
      sort_desc: "desc",
      filter: {
        search: null,
        orderBy: "id",
        sort: "desc",
      },
    };
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
    registerStoreModule(GIFT_MODULE_NAME, gift_module);
  },
  computed: {
    items: {
      get() {
        return store.getters[GIFT_MODULE_NAME + "/" + GIFT_ITEMS];
      },
      set(value) {},
    },
    error: {
      get() {
        return store.getters[GIFT_MODULE_NAME + "/" + GIFT_ERROR];
      },
      set(value) {},
    },
    formattedItem() {
      let results = [];
      if (this.items === null || !("data" in this.items)) return [];
      this.pagination = this.items;

      this.items.data.forEach((currentItem) => {
        results.push({
          id: currentItem.id,
          name: currentItem.name,
          image: currentItem.image_link,
        });
      });

      return results;
    },
  },
  methods: {
    getGiftResult() {
      if (!this.$isGiftVisible) {
        return false;
      }
      let self = this;
      this.$store.dispatch(GIFT_MODULE_NAME + "/" + GIFT_GET_ITEMS, {
        url: GIFT_BASE_URL,
        filters: {
          like: self.filter.search,
          page: self.page,
          per_page: self.per_page,
          sort: self.filter.sort,
          order_by: self.filter.orderBy,
          status_id: self.status_id,
        },
      });
    },
    removeGift(id) {
      this.$store
        .dispatch(GIFT_MODULE_NAME + "/" + GIFT_DELETE_ITEM, {
          url: GIFT_BASE_URL + "/" + id,
        })
        .then(() => {
          if (!this.error) {
            this.successMessage = this.$t("general.successfully_deleted");
            this.getGiftResult();
          } else this.errorMessages.push(this.error);
        });
    },
    sortOrder(orderBy, sort) {
      this.page = 1;
      this.filter.orderBy = orderBy;
      this.filter.sort = sort;
      this.getGiftResult();
    },
    setPage(page) {
      this.page = page;
      this.getGiftResult();
    },
    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
  },
  mounted() {
    this.getGiftResult();
  },
  watch: {
    "filter.search": function () {
      this.debouncedFilterSearch();
    },
    successMessage: function () {
      this.debouncedResetValues();
    },
    errorMessages: function () {
      this.debouncedResetValues();
    },
  },
  created: function () {
    this.debouncedFilterSearch = _.debounce(this.getGiftResult, 500);
    this.debouncedResetValues = _.debounce(this.resetMessages, 2000);
  },
};
</script>

<style scoped>
.gift-panel {
  padding: 16px;
}

.gift-card {
  background: #fff;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

/* ==================== Toolbar ==================== */
.gift-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  border-bottom: 1px solid #e2e8f0;
}

.gift-search {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
  height: calc(2.25rem + 2px);
}

.gift-search__icon {
  position: absolute;
  left: 12px;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  font-size: 18px;
  line-height: 1;
  color: #3f87f5;
  pointer-events: none;
}

.gift-search__input {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 0 0.75rem 0 38px;
  border: 1px solid #cfd5df;
  border-radius: 10px;
  color: #1e293b;
  font-size: 14px;
  line-height: 1.5;
  background: #fff;
}

.gift-search__input:focus {
  border-color: var(--primaryColor, #3e416d);
  box-shadow: 0 0 0 3px rgba(62, 65, 109, 0.16);
  outline: none;
}

.gift-toolbar__actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 4px;
}

.gift-sort-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  min-height: 36px;
  border-radius: 8px;
  color: #64748b;
  font-size: 18px;
  text-decoration: none;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.gift-sort-btn:active {
  transform: scale(0.95);
  opacity: 0.8;
}

/* ==================== Table ==================== */
.gift-table-wrap {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.gift-table th,
.gift-table td {
  font-size: 14px;
  font-weight: 400;
  vertical-align: middle;
  line-height: 1.4;
}

.gift-table thead th {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}

.gift-table tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

.gift-table tbody tr:nth-child(odd) {
  background-color: #ffffff;
}

.gift-avatar-wrap {
  flex: 0 0 auto;
}

.gift-avatar {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  object-fit: cover;
}

.gift-name {
  margin-left: 12px;
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}

/* ==================== Action buttons ==================== */
.gift-actions {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
}

.gift-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
  color: #fff;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
}

.gift-action-btn:active:not(:disabled) {
  transform: scale(0.98);
  opacity: 0.85;
}

.gift-action-btn:disabled {
  opacity: 0.5;
  pointer-events: none;
}

.gift-action-btn--added {
  opacity: 0.7;
}

/* ==================== Pagination ==================== */
.gift-card ::v-deep .pagination {
  padding: 8px 16px 16px;
}

/* ==================== Mobile (959px) ==================== */
@media (max-width: 959px) {
  .gift-panel {
    padding: 8px;
  }

  .gift-card {
    border-radius: 12px;
  }

  .gift-toolbar {
    flex-wrap: wrap;
    padding: 12px;
    gap: 8px;
  }

  .gift-search {
    flex: 1 1 100%;
    height: 44px;
  }

  .gift-search__input {
    padding: 0 14px 0 42px;
    font-size: 16px;
  }

  .gift-search__icon {
    left: 14px;
    font-size: 20px;
  }

  .gift-sort-btn {
    min-width: 44px;
    min-height: 44px;
    font-size: 20px;
  }

  .gift-table th,
  .gift-table td {
    padding: 10px 8px;
    font-size: 14px;
  }

  .gift-table thead th {
    font-size: 13px;
    white-space: nowrap;
  }

  /* Hide avatar on mobile */
  .gift-avatar-wrap {
    display: none;
  }

  .gift-name {
    margin-left: 0;
    font-size: 14px;
    word-break: break-word;
  }

  .gift-action-btn {
    min-height: 44px;
    padding: 10px 16px;
    font-size: 14px;
  }

  .gift-card ::v-deep .pagination {
    padding: 8px 12px 12px;
  }
}

/* ==================== Hover ==================== */
@media (hover: hover) and (pointer: fine) {
  .gift-sort-btn:hover {
    background: #f6f7fb;
    color: var(--primaryColor, #3e416d);
    cursor: pointer;
  }

  .gift-action-btn:hover:not(:disabled) {
    opacity: 0.92;
    cursor: pointer;
  }
}

/* ==================== Reduced Motion ==================== */
@media (prefers-reduced-motion: reduce) {
  .gift-sort-btn:active,
  .gift-action-btn:active {
    transform: none;
  }
}
</style>
